import ProgressWidget from './ProgressWidget.vue';

export default ProgressWidget;
